import script from "./AdminHomeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminHomeView.vue?vue&type=script&setup=true&lang=ts"

import "./AdminHomeView.vue?vue&type=style&index=0&id=571d0ea5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-571d0ea5"]])

export default __exports__